import React, { useState } from "react";
import { PlayCircleTwoTone } from "@ant-design/icons";
import Vimeo from "@u-wave/react-vimeo";
import Video from "./Video";
import { MuxVideo } from "@tiicker/util/lib/contentful/types";
import VideoJS from "./VideoJS";
import Modal from "components/Modal/Modal";
import styles from "./VideoPlayer.module.scss";
import classNames from "classnames";

type Props = {
  thumbnailUrl: string;
  thumbnailClassName?: string;
  video?: MuxVideo;
  videoUrl: string;
  inline?: boolean;
  stopAutoplay?: boolean;
};

const VideoPlayer: React.FC<Props> = (props) => {
  const [modalState, setModalState] = useState({
    visible: false,
  });

  const playbackUrl =
    props.video && props.video.playbackId
      ? `https://stream.mux.com/${props.video.playbackId}.m3u8`
      : props.videoUrl;

  const thumbnail =
    props.thumbnailUrl === "" && props.video && props.video.playbackId
      ? `https://image.mux.com/${props.video.playbackId}/thumbnail.jpg`
      : props.thumbnailUrl;

  const showVideoModal = (event) => {
    event.preventDefault();
    setModalState({
      visible: true,
    });
  };

  const modalCancel = () => {
    setModalState({
      visible: false,
    });
  };

  const renderVideoPlayer = (url: string) => {
    if (url.includes("vimeo.com")) {
      return (
        <Vimeo
          video={playbackUrl}
          autoplay={!props.stopAutoplay}
          responsive
          muted={props.inline}
          loop={props.inline}
          className={classNames(
            styles.VideoPlayer__video_player,
            styles.VideoPlayer__video_player__vimeo
          )}
        />
      );
    }

    if (url.includes("stream.mux")) {
      return <Video videoUrl={url} poster={thumbnail} controls />;
    }

    return <Video videoUrl={url} stopAutoplay={props.stopAutoplay} />;
  };

  if (props.inline) {
    return (
      <div
        className={classNames(
          styles.VideoPlayer__player_wrapper,
          styles.VideoPlayer__player_wrapper__inline
        )}
        id="video-player"
      >
        {renderVideoPlayer(playbackUrl)}
      </div>
    );
  }

  return (
    <>
      <div
        className={styles.VideoPlayer__image_wrapper}
        onClick={showVideoModal}
      >
        <img
          className={classNames(
            styles.VideoPlayer__thumbnail,
            props.thumbnailClassName
          )}
          src={thumbnail + "?w=940"}
        />
        <div className={styles.VideoPlayer__image_text}>
          <PlayCircleTwoTone twoToneColor="#A9A9A9" />
          <p>Watch Video</p>
        </div>
      </div>
      <Modal
        visible={modalState.visible}
        modalClassName={styles.modal}
        width={940}
        onClose={modalCancel}
      >
        <div className={styles.VideoPlayer__player_wrapper} id="video-player">
          {renderVideoPlayer(playbackUrl)}
        </div>
      </Modal>
    </>
  );
};

export default VideoPlayer;
